import { render, staticRenderFns } from "./arbitrage-order-detail.vue?vue&type=template&id=77ecbc4a&scoped=true&"
import script from "./arbitrage-order-detail.vue?vue&type=script&lang=js&"
export * from "./arbitrage-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./arbitrage-order-detail.vue?vue&type=style&index=0&id=77ecbc4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ecbc4a",
  null
  
)

export default component.exports